import { gql } from '@apollo/client';

export default gql`
  mutation processHotelVoucherRefund(
    $bookingReference: String!
    $refundAmount: Float!
    $currency: Currency!
    $email: String!
    $firstName: String!
    $lastName: String!
    $language: String!
    $expiryDate: String!
  ) {
    processHotelVoucherRefund(
      bookingReference: $bookingReference
      refundAmount: $refundAmount
      currency: $currency
      email: $email
      firstName: $firstName
      lastName: $lastName
      language: $language
      expiryDate: $expiryDate
    ) {
      reference
      paymentsRefundBalance
    }
  }
`;
